<template>
    <div class="my-page">
      <!-- 顶部用户信息 -->
      <div class="user-card">
        <img class="avatar" src="@/assets/logo.png" />
        <div class="info">
          <p class="name">{{ authorized ? userName : '' }}</p>
          <p class="balance">余额：￥{{ balance.toFixed(2) }}</p>
        </div>
      </div>
  
      <!-- 当月三餐统计（一行三卡片） -->
      <div class="meal-row">
        <div
          v-for="m in mealData"
          :key="m.label"
          class="meal-item"
          @click="go(m)"
        >
          <span class="label">{{ m.label }}</span>
          <span class="count">{{ m.count }}</span>
        </div>
      </div>
  
      <!-- 列表式菜单 -->
      <div class="list-menu">
        <div
          v-for="item in listMenu"
          :key="item.text"
          :class="['list-item', { 'router-link-exact-active': $route.path === item.path }]"
          @click="go(item)"
        >
          <i :class="['icon', item.icon]" :style="{ color: item.color }"></i>
          <span class="text">{{ item.text }}</span>
          <i class="arrow el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  
  export default {
    data() {
      return {
        authorized: true,
        userName: '',
        balance: 0,
        mealData: [
          { label: '当月早餐', count: 0 },
          { label: '当月午餐', count: 0 },
          { label: '当月晚餐', count: 0 }
        ],
        listMenu: [
          { text: '余额记录', icon: 'el-icon-notebook-1', color: '#67c23a', path: '/yuerRecord' },
          { text: '报餐记录', icon: 'el-icon-tickets', color: '#67c23a', path: '/baocanRecord' },
          { text: '人脸拍照', icon: 'el-icon-money', color: '#e6a23c' }
        ]
      };
    },
    methods: {
      go(item) {
        if (item.path) {
          this.$router.push(item.path);
        } else {
          this.$message.info(`点击了 ${item.text || item.label}`);
        }
      },
      fetchUserData() {
        this.$axios.get('/api/show_yuer_name') // 替换为实际的 API 地址
          .then(response => {
            if (response.data.code === 0) {
              const data = response.data.data;
              console.log(data)
              this.userName = data.name;
              this.balance = data.money;
              this.mealData[0].count = data.zaocan; // 当月早餐
              this.mealData[1].count = data.wucan; // 当月午餐
              this.mealData[2].count = data.wancan; // 当月晚餐
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch(error => {
            this.$message.error('获取用户数据失败');
            console.error(error);
          });
      }
    },
    mounted() {
      this.fetchUserData(); // 在组件加载时调用 API 获取数据
    }
  };
  </script>
  
  <style scoped>
  .my-page {
    background: #f5f7fa;
    min-height: 100vh;
    padding: 12px;
  }
  
  /* 顶部卡片 */
  .user-card {
    display: flex;
    align-items: center;
    background: linear-gradient(135deg, #ffca28, #ffa726);
    color: #fff;
    padding: 20px;
    border-radius: 12px;
    margin-bottom: 16px;
  }
  .avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-right: 12px;
    border: 2px solid #fff;
    object-fit: cover;
  }
  .name {
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 4px;
  }
  .balance {
    font-size: 14px;
    margin: 0;
  }
  
  /* 三餐统计 */
  .meal-row {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 16px;
  }
  .meal-item {
    flex: 1;
    background: #fff;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 14px 0 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .05);
    cursor: pointer;
  }
  .meal-item .label {
    font-size: 13px;
    color: #333;
    margin-bottom: 4px;
  }
  .meal-item .count {
    font-size: 20px;
    font-weight: 600;
    color: #ff9800;
  }
  
  /* 列表式菜单 */
  .list-menu {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
  }
  .list-item {
    display: flex;
    align-items: center;
    padding: 14px 12px;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
  }
  .list-item:last-child {
    border-bottom: none;
  }
  .list-item .icon {
    font-size: 20px;
    margin-right: 10px;
  }
  .list-item .text {
    flex: 1;
    font-size: 15px;
    color: #333;
  }
  .list-item .arrow {
    font-size: 14px;
    color: #c0c4cc;
  }
  </style>